// Badge colorida para "tempo na etapa" — calculada a partir da mesma data já usada em
// tempoDecorrido() (dataAtualizacao). Puramente visual, não deriva de nenhum dado novo.
const FAIXAS = [
    { max: 0, label: "Hoje", className: "bg-success/10 text-success" },
    { max: 1, label: "Ontem", className: "bg-primary/10 text-primary" },
    { max: 3, label: "3 dias", className: "bg-sky-100 text-sky-700" },
    { max: 7, label: "7 dias", className: "bg-amber-100 text-amber-700" },
    { max: 15, label: "15 dias", className: "bg-orange-100 text-orange-700" },
    { max: 30, label: "30 dias", className: "bg-rose-100 text-rose-700" },
];

// Exportada para o card do Kanban usar o mesmo corte de "crítico" (>30 dias parado na etapa) no
// destaque visual de tarefa atrasada, sem duplicar a régua de dias.
export function calcularFaixa(dataIso) {
    if (!dataIso) return { label: "-", className: "bg-muted text-muted-foreground", dias: null, critico: false };
    const dias = Math.floor((Date.now() - new Date(dataIso).getTime()) / 86400000);
    if (dias < 0) return { ...FAIXAS[0], dias, critico: false };
    const faixa = FAIXAS.find(f => dias <= f.max);
    if (faixa) return { ...faixa, dias, critico: false };
    return { label: "Mais de 30 dias", className: "bg-destructive/10 text-destructive", dias, critico: true };
}

export default function TempoBadge({ data }) {
    const { label, className } = calcularFaixa(data);
    return (
        <span className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap ${className}`}>
            {label}
        </span>
    );
}
